var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxplot-cotainer-box"},_vm._l((_vm.optionArr),function(item,index){return _c('div',{key:index,staticClass:"boxploy-item-box"},[_c('v-chart',{attrs:{"options":item.barOption,"autoresize":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }